import {
  ChangeDetectorRef,
  Component,
  DoCheck,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { RoomFilter, RoomFilterModel } from '@fantaz/shared/data-access/models';
import { getFilterRangesByList } from '@fantaz/shared/utils/filters';

@Component({
  selector: 'fz-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})
export class FilterRoomsComponent implements OnInit, DoCheck {
  @Output()
  filterChange: EventEmitter<RoomFilterModel[]> = new EventEmitter<
    RoomFilterModel[]
  >();
  @Input()
  arrayToFilter: any[] | null = [];
  firstPlayInstance: string;
  elementNumber: number | null = 0;

  @Input()
  model: RoomFilterModel[] = [];

  @Output()
  modelChange: EventEmitter<RoomFilterModel[]> = new EventEmitter<
    RoomFilterModel[]
  >();

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    if (this.arrayToFilter && this.arrayToFilter.length > 0) {
      for (let i = 0; i < this.model.length; i++) {
        this.model[i].values = this.generateRanges(
          this.model[i],
          this.arrayToFilter,
        );
      }
      this.firstPlayInstance = this.arrayToFilter[0].playInstanceUuid;
      this.elementNumber = this.arrayToFilter.length as number;
      this.modelChange.emit(this.model);
    }
  }

  ngDoCheck() {
    if (
      (this.arrayToFilter &&
        this.arrayToFilter.length > 0 &&
        this.arrayToFilter[0].playInstanceUuid !== this.firstPlayInstance) ||
      (this.arrayToFilter && this.arrayToFilter.length !== this.elementNumber)
    ) {
      this.ngOnInit();
    }
  }

  updateFilterSelected(item: RoomFilter) {
    item.selected = !item.selected;
    this.filterChange.emit(this.model);
  }

  getCurrencyCode(item: RoomFilter) {
    if (item.label.includes('$')) {
      return 'USD';
    }
    return '';
  }

  private generateRanges(
    filterProperties: RoomFilterModel,
    arrayToFilter: any[] | null,
  ): RoomFilter[] {
    if (filterProperties.static) {
      return filterProperties.values as RoomFilter[];
    }
    const element: number[] = [];
    const result: RoomFilter[] = [];

    if (arrayToFilter) {
      for (let i = 0; i < arrayToFilter.length; i++) {
        if (!element.includes(arrayToFilter[i][filterProperties.filter])) {
          element.push(arrayToFilter[i][filterProperties.filter]);
        }
      }
    }

    const filterRanges = getFilterRangesByList(element, {
      symbol: filterProperties.symbol,
    });

    for (const element in filterRanges) {
      result.push({
        key: `${filterRanges[element].key}`,
        label: `${filterRanges[element].name}`,
        type: `${filterRanges[element].type}`,
        selected: false,
        value: {
          start: filterRanges[element].values[0],
          end: filterRanges[element].values[1],
        },
      });
    }

    return result;
  }
}
